import {format} from "date-fns";
import {de} from "date-fns/locale";

export const weekScaleAltTemplate = (a, b) => {
    return `${format(a, "d. MMM", {locale: de})} - ${format(b, "d. MMM", {locale: de})}`;
};
export const bigScales = [
    { unit: "year", step: 1, format: "yyyy" },
    { unit: "quarter", step: 1, format: "QQQQ yyyy" },
    { unit: "month", step: 1, format: "MMMM yyyy" },
    { unit: "week", step: 1, format: weekScaleAltTemplate },
];
